"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyFeaturedContentV3Update = void 0;
exports.featuredContentV3UpdateSetMock = featuredContentV3UpdateSetMock;
exports.featuredContentV3Update = featuredContentV3Update;
exports.useMutationFeaturedContentV3Update = useMutationFeaturedContentV3Update;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function featuredContentV3UpdateSetMock(mock) {
    setMock = mock;
}
async function featuredContentV3Update(body, params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(body, params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-athenaeum-service/v3/featured-content/${params.id}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((params.forceStatusCheck) && (await (0, is_down_1.wolfAthenaeumServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { data: body, headers, method: 'PUT', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyFeaturedContentV3Update = 'wolf-athenaeum-service:featuredContentV3Update:put';
function useMutationFeaturedContentV3Update(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyFeaturedContentV3Update }, mutationOptions));
}
function mutationFn({ body, params }) {
    const promise = featuredContentV3Update(body, params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=featured-content-v3-update.js.map